"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react")); // Maybe handle the loading here or another HOC


exports.withSelector = function (WrappedComponent, propsOrSelector, className) {
  if (className === void 0) {
    className = '';
  }

  return function (props) {
    var selector = propsOrSelector;

    if (typeof propsOrSelector === 'object') {
      selector = propsOrSelector.selector || propsOrSelector['data-selector'];
    }

    if (props.hide) {
      return null;
    }

    return react_1.default.createElement(WrappedComponent, __assign({
      "data-selector": selector
    }, props, {
      className: "" + className + (props.className ? " " + props.className : '')
    }));
  };
};